import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { API_BASE_URL, GeneralContractorClient, NotificationClient } from '@api/api';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { coreProviders, httpInterceptorProviders } from '@core';
import { appInitializerProviders } from '@core/initializers';
import { environment } from '@env/environment';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { formlyConfig } from '@shared';
import { AppComponent } from 'app/app.component';
import { materialProviders } from 'app/material-config';
import { routes } from 'app/routes/routes';
import { GetProtectedResourcesMap, msalConfig, protectedResources } from '../auth-config';

// Required for AOT compilation
export function TranslateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    httpInterceptorProviders,
    appInitializerProviders,
    coreProviders,
    materialProviders,
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
    importProvidersFrom([
      FormlyModule.forRoot(formlyConfig),
      MatDialogModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: TranslateHttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ]),
    {
      provide: MSAL_INSTANCE,
      useValue: new PublicClientApplication(msalConfig),
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useValue: {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: protectedResources.api.scopes,
        },
        loginFailedRoute: 'login',
      },
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useValue: {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: GetProtectedResourcesMap(),
      },
    },
    { provide: API_BASE_URL, useFactory: () => environment.baseUrl },
    GeneralContractorClient,
    NotificationClient,
  ],
}).catch(err => console.error(err));
